import {
  AvailableStatus,
  ProductUpdateFields,
  UpdateProductMutationVariables,
} from 'graphql/generatedModel';

export const getOrdersToEditForProdList = (
  productsData: any,
  updatedProduct: UpdateProductMutationVariables,
) => {
  const { date, productId, productName, shippingName } = updatedProduct;
  const fields = (updatedProduct.fields as ProductUpdateFields[]) || [];

  // Step 1: find product list for the given date
  const allProductsForDate = productsData[date]?.productsList || [];

  // Step 2: get all target orderIds from updatedProduct.fields
  const targetOrderIds = new Set(fields.map((f) => `${f.orderId}`));

  // Step 3: quick lookup for field (e.g., partNum) by string orderId
  const fieldByOrderId = new Map<string, ProductUpdateFields>();
  for (const f of fields) {
    fieldByOrderId.set(`${f.orderId}`, f);
  }

  // Step 4: collect all matching productionListOrders
  let matchedItems: { product: any; order: any; orderId: string }[] = [];

  for (const product of allProductsForDate) {
    if (product.shippingPointName !== shippingName) continue;

    for (const order of product.productionListOrders) {
      if (targetOrderIds.has(`${order.orderId}`)) {
        matchedItems.push({
          orderId: `${order.orderId}`,
          product,
          order,
        });
      }
    }
  }

  // Step 5: remove orders where not all of them are DONE for the same orderId and group by orderId
  const ordersGrouped = matchedItems.reduce((acc: Record<string, typeof matchedItems>, item) => {
    acc[item.orderId] = acc[item.orderId] || [];
    acc[item.orderId].push(item);
    return acc;
  }, {});

  for (const orderId in ordersGrouped) {
    const allDone = ordersGrouped[orderId].every(
      ({ order }) => order.productStatus === AvailableStatus.DONE,
    );
    if (!allDone) {
      delete ordersGrouped[orderId]; // remove this entire order group
    }
  }

  // Step 6: map to required output format
  const result = Object.entries(ordersGrouped).map(([orderId, arr]) => {
    const field = fieldByOrderId.get(orderId);

    return {
      orderId,
      positionParts: arr.map(({ order, product }) => ({
        linkArticle: String(product.articleId),
        description: product.description,
        newQuantity: order.distributed,
        partNum: field?.partNum ?? 1,
      })),
    };
  });

  return result;
};
